module.exports = __webpack_public_path__ + "files/05da7875233bd6468f7949e52ba752db.png";